import { TUNABLES } from "../config";

/**
 * A duel's code (B3.2): five characters that are its ID on the card, its seed text (D-028) and
 * the room in a link (`?room=K7Q2M`). Since B3.5 the lobby server mints them too, so the code
 * lives with the protocol, not with the page. Pure, so it is unit-tested in Node.
 */

/** No 0, 1, I, L or O: a code read aloud or copied from a screenshot is not misread. */
export const ROOM_CODE_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";

/** A code from one unsigned 32-bit draw: the same draw gives the same code. */
export function roomCodeFrom(draw: number): string {
  const base = ROOM_CODE_ALPHABET.length;
  let rest = Math.floor(Math.abs(draw)) % base ** TUNABLES.lobby.roomCodeLength;
  let code = "";
  for (let place = 0; place < TUNABLES.lobby.roomCodeLength; place += 1) {
    code = ROOM_CODE_ALPHABET.charAt(rest % base) + code;
    rest = Math.floor(rest / base);
  }
  return code;
}

/** A typed or linked code: trimmed and upper-cased; undefined when it is not a code. */
export function cleanRoomCode(text: string): string | undefined {
  const code = text.trim().toUpperCase();
  const pattern = new RegExp(`^[${ROOM_CODE_ALPHABET}]{${TUNABLES.lobby.roomCodeLength}}$`);
  return pattern.test(code) ? code : undefined;
}
